import React, { useState } from 'react';

const getErrorMessage = (errorVal) => {
  if (!errorVal) return '';
  if (typeof errorVal === 'string') return errorVal;
  if (typeof errorVal === 'object') {
    if (errorVal.message && typeof errorVal.message === 'string') {
      return errorVal.message;
    }
    if (errorVal.message && errorVal.message.statusMessage) {
      return errorVal.message.statusMessage;
    }
    if (errorVal.statusMessage) {
      return errorVal.statusMessage;
    }
    return errorVal.error || JSON.stringify(errorVal);
  }
  return String(errorVal);
};

function SubscribePage() {
  const [msisdn, setMsisdn] = useState('');
  const [showDoiPopup, setShowDoiPopup] = useState(false);
  const [doiInput, setDoiInput] = useState('');
  const [message, setMessage] = useState('');
  const [popupMessage, setPopupMessage] = useState('');
  const [status, setStatus] = useState('IDLE'); // 'IDLE', 'PROCESSING', 'SUCCESS', 'ERROR'

  const handleSubscribeClick = (e) => {
    if (e) e.preventDefault();
    setMessage('');
    const trimmedMsisdn = msisdn.trim();

    if (!/^\d+$/.test(trimmedMsisdn) || trimmedMsisdn.length < 10) {
      setMessage('Please enter a valid mobile number (e.g. 234XXXXXXXXXX).');
      return;
    }

    setShowDoiPopup(true);
    setStatus('IDLE');
    setDoiInput('');
    setPopupMessage('');
  };

  const handleCancelDoi = () => {
    setShowDoiPopup(false);
    setDoiInput('');
    setPopupMessage('');
    setStatus('IDLE');
  };

  const handleSendDoi = async () => {
    setPopupMessage('');
    const trimmedInput = doiInput.trim();

    if (trimmedInput === '2') {
      handleCancelDoi();
      return;
    }

    if (trimmedInput !== '1') {
      setPopupMessage('Invalid option. Reply with 1 to confirm or 2 to decline.');
      return;
    }

    setStatus('PROCESSING');

    try {
      const res = await fetch('https://ng.gameit.in/api/ussd/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ msisdn: msisdn.trim(), pisipid: '395', channel: 'WEB' }),
      });
      const data = await res.json();

      if (res.ok && data.success) {
        setStatus('SUCCESS');
      } else {
        setStatus('ERROR');
        setPopupMessage(getErrorMessage(data.error) || 'Subscription failed. Please try again.');
      }
    } catch (err) {
      console.error(err);
      setStatus('ERROR');
      setPopupMessage('Network error. Failed to reach server.');
    }
  };

  const handleClosePopup = () => {
    setShowDoiPopup(false);
    setDoiInput('');
    setPopupMessage('');
    setStatus('IDLE');
  };

  return (
    <div className="h-screen w-screen bg-slate-950 flex justify-center items-center p-0 select-none relative overflow-hidden">
      
      {/* Background Glow effects */}
      <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] bg-teal-500/5 rounded-full blur-[140px] pointer-events-none" />
      <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] bg-emerald-500/5 rounded-full blur-[140px] pointer-events-none" />

      {/* Main Landing Container */}
      <div className="w-full max-w-[390px] bg-zinc-900 h-screen max-h-screen flex flex-col justify-between relative shadow-2xl border-x border-zinc-800/50 overflow-hidden">
        
        {/* Banner Image */}
        <div className="w-full h-[38vh] max-h-[280px] min-h-[140px] overflow-hidden bg-zinc-950 relative border-b border-zinc-800 flex-shrink-0">
          <img 
            src="/soccer_quiz_banner.png" 
            alt="Soccer Quiz" 
            className="w-full h-full object-cover"
          />
        </div>

        {/* Content Area */}
        <div className="flex-1 flex flex-col justify-between p-4 sm:p-5 overflow-hidden">
          
          {/* Top description */}
          <div className="flex flex-col gap-1.5 text-center">
            <h1 className="text-white text-lg sm:text-xl font-black tracking-tight uppercase ">Soccer Quiz</h1>
            <p className="text-zinc-400 text-xs sm:text-[13px] leading-relaxed font-medium px-1">
              Soccer Quiz brings you premium football content, daily quizzes, real-time live scores, and exclusive prizes. Subscribe today to test your knowledge!
            </p>
          </div>

          {/* Form & Actions */}
          <div className="my-auto py-2 flex flex-col gap-4">
            
            {/* Input mobile number */}
            <div className="flex flex-col gap-1.5 ">
              <label className="block text-[10px] font-bold text-zinc-500 uppercase tracking-widest text-center">
                Enter your mobile number:
              </label>
              <input
                type="tel"
                value={msisdn}
                onChange={(e) => setMsisdn(e.target.value)}
                placeholder="234XXXXXXXXXX"
                className="w-full px-3 py-3 bg-zinc-950 border border-zinc-800 rounded-xl text-white font-bold text-center placeholder-zinc-600 focus:outline-none focus:border-teal-400 transition-colors shadow-inner text-sm"
              />
              {message && (
                <span className="text-red-500 text-[11px] text-center font-semibold mt-0.5 animate-pulse">
                  ⚠️ {message}
                </span>
              )}
            </div>

            {/* Selection Daily Pack option */}
            <div className="flex items-center justify-center gap-2 py-0.5">
              <label className="flex items-center gap-2 text-zinc-300 font-bold text-xs cursor-pointer select-none">
                <input
                  type="radio"
                  checked={true}
                  readOnly
                  className="w-3.5 h-3.5 text-teal-500 bg-zinc-950 border-zinc-800 focus:ring-teal-500 focus:ring-offset-zinc-950 accent-teal-500"
                />
                <span>Daily @ ₦150</span>
              </label>
            </div>

            {/* Subscribe Now Button */}
            <button
              onClick={handleSubscribeClick}
              className="w-full py-3 bg-teal-500 hover:bg-teal-600 text-black font-black text-sm sm:text-base rounded-xl transition-colors tracking-widest uppercase active:scale-[0.99] shadow-lg shadow-teal-500/10 mt-1"
            >
              Subscribe Now
            </button>

          </div>

          {/* Footer info */}
          {/* <div className="text-center border-t border-zinc-800/80 pt-3 flex-shrink-0">
            <p className="text-[9px] text-zinc-500 leading-relaxed font-medium">
              By clicking "Subscribe Now", you agree to the Terms of Service. Charges will be billed directly from your airtime.
            </p>
          </div> */}

        </div>

      </div>

      {/* Carrier-style USSD popup overlay */}
      {showDoiPopup && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-xs z-50 flex items-center justify-center p-4">
          
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-[320px] overflow-hidden flex flex-col p-6 border border-zinc-100">
            
            <h3 className="text-zinc-950 font-bold text-lg mb-3 border-b border-zinc-100 pb-2">
              Send command
            </h3>

            {status === 'IDLE' && (
              <div className="flex flex-col gap-4">
                <p className="text-zinc-700 text-sm leading-relaxed font-medium">
                  To sign up to Soccer Quiz service charging @ ₦150 per day. Please reply with Yes to confirm or No to decline.
                  <span className="block mt-3 font-bold text-zinc-900">1. Yes</span>
                  <span className="block font-bold text-zinc-900">2. No</span>
                </p>
                
                <input
                  type="text"
                  value={doiInput}
                  onChange={(e) => setDoiInput(e.target.value)}
                  placeholder="Type reply here..."
                  className="w-full border-b-2 border-teal-500 focus:outline-none text-zinc-950 font-bold py-1.5 px-1 text-sm placeholder-zinc-400"
                  autoFocus
                />

                {popupMessage && (
                  <span className="text-red-500 text-xs font-semibold leading-relaxed mt-1">
                    ⚠️ {popupMessage}
                  </span>
                )}

                <div className="flex justify-end gap-6 mt-4 font-bold text-sm tracking-wider">
                  <button
                    onClick={handleCancelDoi}
                    className="text-teal-600 hover:text-teal-700 uppercase cursor-pointer"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleSendDoi}
                    className="text-teal-600 hover:text-teal-700 uppercase cursor-pointer"
                  >
                    Send
                  </button>
                </div>
              </div>
            )}

            {status === 'PROCESSING' && (
              <div className="flex flex-col items-center justify-center py-6 gap-3">
                <div className="w-10 h-10 border-4 border-teal-100 border-t-teal-500 rounded-full animate-spin" />
                <span className="text-zinc-700 text-sm font-bold">Connecting to network...</span>
              </div>
            )}

            {status === 'SUCCESS' && (
              <div className="flex flex-col items-center justify-center py-4 gap-4">
                <div className="w-12 h-12 bg-emerald-50 border border-emerald-200 rounded-full flex items-center justify-center">
                  <svg className="w-8 h-8 text-emerald-600" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <h3 className="text-emerald-800 font-bold text-base text-center">Subscription Successful</h3>
                <p className="text-zinc-600 text-xs text-center font-medium px-2 leading-relaxed">
                  You have successfully subscribed to Soccer Quiz Daily Pack. Thank you!
                </p>
                <button
                  onClick={handleClosePopup}
                  className="mt-3 px-6 py-2.5 bg-teal-500 hover:bg-teal-600 text-black font-extrabold text-sm rounded-xl transition-colors uppercase cursor-pointer shadow-md shadow-teal-500/10 active:scale-[0.98]"
                >
                  OK
                </button>
              </div>
            )}

            {status === 'ERROR' && (
              <div className="flex flex-col items-center justify-center py-4 gap-4">
                <div className="w-12 h-12 bg-red-50 border border-red-200 rounded-full flex items-center justify-center">
                  <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </div>
                <h3 className="text-red-800 font-bold text-base text-center">Action Failed</h3>
                <p className="text-zinc-600 text-xs text-center font-medium px-2 leading-relaxed">
                  {popupMessage || 'Something went wrong. Please check again.'}
                </p>
                <button
                  onClick={handleClosePopup}
                  className="mt-3 px-6 py-2.5 bg-red-600 hover:bg-red-700 text-white font-extrabold text-sm rounded-xl transition-colors uppercase cursor-pointer active:scale-[0.98]"
                >
                  OK
                </button>
              </div>
            )}

          </div>

        </div>
      )}

    </div>
  );
}

export default SubscribePage;
